<template>
  <div>
    <a-card v-if="queryList" :bordered="false">
      <a-row :gutter="8">
        <a-col>
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="6">
                <a-col :span="6" v-if="userType == '00'">
                  <a-form-item label="企业名称">
                    <a-select
                      showSearch

                      optionFilterProp="children"
                      v-model="queryParam.enterpriseId"
                      :allowClear="true"
                    >
                      <a-select-option v-for="type in enterpriseMap" :title="type.enterpriseName" :key="type.enterpriseId">{{type.enterpriseName}}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="用户名">
                    <a-input  v-model="queryParam.loginName"/>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="状态">
                    <a-select  v-model="queryParam.status" :allowClear="true">
                      <!--<a-select-option :value="''" >全部</a-select-option>-->
                      <a-select-option :value="'0'" title="正常">正常</a-select-option>
                      <a-select-option :value="'1'" title="禁用">禁用</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6" :style="{ textAlign: 'right' }">
                <span class="table-page-search-submitButtons">
                  <a-button type="primary"  htmlType="submit"  @click="$refs.table.refresh(true)">查询</a-button>
                  <a-button style="margin-left: 8px" @click="() => queryParam = {}">清空</a-button>
                </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <a-divider></a-divider>
          <div>
            <a-row :gutter="6">
              <a-col :span="3">
                <a-dropdown v-if="selectedRowKeys.length > 0 && deleteUser">
                  <a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>
                </a-dropdown>
              </a-col>
              <a-col :span="4" :offset="17" v-if="addAccount" :style="{ textAlign: 'right' }">
                <a-button type="primary" icon="plus" @click="enterAdd()">新增</a-button>
              </a-col>
            </a-row>
          </div>
          <s-table
            style="margin-top: 20px"
            size="default"
            ref="table"
            rowKey="userId"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
            :columns="columns"
            :data="loadData"
            bordered
          >
          <span slot="status" slot-scope="text,record">
            <a-switch :checked="record.status=='0'" @change="onChangeStatus(record)" :disabled="!editAccount"/>
          </span>
          <span slot="action" slot-scope="text, record">
            <a v-if="enterpriseAccountInfo" @click="handleShow(record)">查看</a>
            <a-divider v-if="enterpriseAccountInfo" type="vertical"/>
            <a @click="handleEdit(record)" v-if="editAccount">编辑</a>
            <a-divider type="vertical" v-if="editAccount && deleteUser"/>
            <a @click="delByIds([record.userId])" v-if="deleteUser">删除</a>
            <a-divider type="vertical" v-if="editAccount"/>
            <a v-if="editAccount" @click="resetPwd(record)">重置密码</a>
          </span>
          <span slot="isMain" slot-scope="text,record">
            <span v-if="record.isMain == '1'">是</span>
            <span v-else>否</span>
          </span>
          </s-table>
        </a-col>
      </a-row>
      <ent-user-register ref="modal" @ok="handleOk" :deptTree="deptTree"/>
      <user-pwd-modal ref="pwdmodal"/>
    </a-card>
    <no-authority v-if="!queryList"></no-authority>
  </div>
</template>

<script>
import { Tree } from 'ant-design-vue'
import { STable, STree } from '@/components'
import { getDeptList, delUser, changEntUserStatus } from '@/api/system'
import { enterpriseUserList } from '../../api/enterprise/entUser'
import { getselectCombox } from '../../api/order/NewlyaddedOrderList'
import EntUserRegister from './modules/EntUserRegister'
import UserPwdModal from '../system/modules/UserPwdModal'
import NoAuthority from './NoAuthority'
import store from '@/store'
import pick from 'lodash.pick'
import { checkPermission } from '@/utils/permissions'

export default {
  name: 'TableList',
  components: {
    Tree,
    STree,
    STable,
    EntUserRegister,
    UserPwdModal,
    NoAuthority
  },
  data () {
    return {
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      queryParam11: {},
      // 表头
      columns: [
        {
          title: '操作',
          width:60,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align:'center',
        },
        {
          title: '用户名',
          dataIndex: 'loginName',
          align:'center'
        },
        {
          title: '昵称',
          dataIndex: 'userName',
          align:'center'
        },
        {
          title: '是否主账号',
          dataIndex: 'isMain',
          scopedSlots: { customRender: 'isMain' },
          align:'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          align:'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          sorter: true,
          align:'center'
        },

      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        this.userType = store.getters.userType
        this.id = store.getters.enterpriseId
        if (this.id !== undefined && this.id !== '') {
          this.queryParam.enterpriseId = this.id
        }
        return enterpriseUserList(Object.assign(parameter, this.queryParam))
        .then(res => {
          console.log('enterpriseUserList', res)
          return res
        })
      },
      searchValue: '',
      deptTree: [],
      expandedKeys: [],
      dataList: [],
      autoExpandParent: true,
      selectedRowKeys: [],
      selectedRows: [],
      enterpriseMap: [],
      userType: '',
      queryList: checkPermission('entUserList:query:list'),
      enterpriseAccountInfo: checkPermission('enterpriseAccountInfo'),
      addAccount: checkPermission('addAccount'),
      editAccount: checkPermission('editAccount'),
      showPermissions: checkPermission('showPermissions'),
      importChildAccount: checkPermission('importChildAccount'),
      deleteUser: checkPermission('entUserList:deleteUser'),
    }
  },
  async created () {
    // document.body.addEventListener('keyup', e => {
    //   if (e.keyCode == 13) {
    //     this.$refs.table.refresh(true)
    //   }
    // })
    await getDeptList().then(res => {
      const data = res.rows
      this.buildtree(data, this.deptTree, 0)
      this.expandedKeys = data.map(m => m.parentId)
      this.dataList = data.map(m => {
        return { key: m.deptId, title: m.deptName }
      })
    })

    // 企业名称
    await getselectCombox().then(res => {
      if (res.code === 0) {
        this.enterpriseMap = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
  },

  methods: {
    enterAdd(){
      this.$refs.modal.add(store.getters.userType)
    },
    onSelectChange (selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    handleShow(record){
      console.log('recode',record)
      this.$refs.modal.edit(record,1)
    },
    handleEdit (record) {
      
      this.$refs.modal.edit(record)
    },
    resetPwd (record) {
      this.$refs.pwdmodal.edit(record)
    },
    onChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleOk (value) {
      if(value == 1){
        this.$refs.table.refresh(true)
      }else{
        this.$refs.table.refresh()
      }
    },
    delByIds (ids) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          delUser({ ids: ids.join(',') }).then(res => {
            if (res.code === 0) {
              that.$message.success(`删除成功`)
              that.handleOk()
            } else {
              that.$message.error(res.msg)
            }
            that.selectedRowKeys = []
          })
        },
      });


    },
    onChangeStatus (record) {
      record.status = record.status === '0' ? '1' : '0'
      changEntUserStatus(pick(record, 'userId', 'status','enterpriseId','userName')).then(res => {
        if (res.code === 0) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(res.msg)
        }
      })
      // 发送状态到服务器
    },
    buildtree (list, arr, parentId) {
      list.forEach(item => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: { title: 'title' },
            children: []
          }
          this.buildtree(list, child.children, item.deptId)
          if (child.children.length === 0) { delete child.children }
          arr.push(child)
        }
      })
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
<style scoped>
  .ant-divider.ant-divider-horizontal {
    margin:12px 0 !important;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px !important;}
</style>
